/* eslint-disable no-console */
import { PollsLocalStorage } from '../store/pollStorage/pollsLocalStorage';
import { isDebugModeEnabled } from './debugConfig';
import { DebugConsoleLogger } from './debugConsoleLogger';

declare global {
  interface Window {
    _getLocalStorageContext: () => void;
  }
}

const POLL_ENV: 'prod' | 'dev' = window.__pollData?.env ?? 'dev';
const ROOT_KEY: string = POLL_ENV === 'prod' ? '@tinkoff/polls' : '@tinkoff/polls-test';
const pollId = window.__pollData?.id;

const injectPollsLocalStorage = () => {
  if (pollId) {
    window._getLocalStorageContext = () => {
      void (async () => {
        const pollsLocalStorage = new PollsLocalStorage(`${ROOT_KEY}/${pollId}`);
        const context = await pollsLocalStorage.get();

        console.log('local storage context', context);
      })();
    };
  }
};

export const injectDebugTools = () => {
  if (!isDebugModeEnabled()) return;

  const debugConsoleLogger = new DebugConsoleLogger();

  debugConsoleLogger.init();
  injectPollsLocalStorage();
};
